import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import styles from "./HomeView.module.scss";
import img_desc from 'assets/img/JPE_description.png';

export default function HomeView() {

  const firstHalf = [
    ["Peter Boettke", "George Mason University"],
    ["William Butos", "Trinity College"],
    ["J.R. Clark", "University of Tennessee at Chattanooga"],
    ["Christopher Coyne", "George Mason University"],
    ["Ramon P. DeGennaro", "University of Tennessee"],
    ["Pierre Garello", "Université Aix-Marseille III"],
    ["Gerald A. Gunderson", "Trinity College"],
    ["P. J. Hill", "Wheaton College"],
    ["Kim Holder", "University of Tennessee at Chattanooga"],
    ["Calvin A. Kent", "Marshall University"],
    ["Peter Kurrild-Klitgaard", "University of Copenhagen"],
    ["Robert Lawson", "Southern Methodist University"],
    ["Dwight R. Lee", "Southern Methodist University"]
  ];

  const secondHalf = [
    ["Peter Leeson", "George Mason University"],
    ["Michael Munger", "Duke University"],
    ["Gerald P. O'Driscoll", "Cato Institute"],
    ["Mark Pennington", "King's College London"],
    ["Benjamin Powell", "Texas Tech University"],
    ["Douglas Rasmussen", "St. John’s University"],
    ["Anja Shortland", "King's College London"],
    ["Vernon Smith", "Chapman University"],
    ["Siri Terjesen", "Florida Atlantic University"],
    ["Clifford Thies", "Shenandoah University"],
    ["Lawrence H. White", "George Mason University"],
    ["Claudia Williamson", "University of Tennessee at Chattanooga"],
    ["Andrew Young", "Texas Tech University"]
  ];

  const renderList = (list) => (
    list.map((entry, index) => (
      <p key={index} className={styles.editorial_board}>
        {entry[0]}, <em>{entry[1]}</em>
      </p>
    ))
  );

  return (

    <Container className="my-5">
      <h2 className="headline2 text-center font-weight-bold">
        The Association of <br /> Private Enterprise Education
      </h2>

      <Row className="mt-5">
        <Col md={4} className="text-justify">
            <div className="d-flex justify-content-center">
                <img
                    src={img_desc}
                    width="100%"
                    alt='JPEE description img'
                />
            </div>
          
          <div className="d-flex justify-content-center"> 
            <h4 className="mt-4 font-weight-bold"> 
              Journal<br/>Editors
            </h4> 
          </div> 
          <p className={`mt-4 ${styles.up_editorial}`}>
              <strong>Editor</strong> - <span>Edward P.</span> <em>Stringham, Trinity College</em>
          </p>
          <p className={styles.editorial_board}>
              <strong>Associate Editor</strong> - <span>Diana W.</span> <em>Thomas, Creighton University</em>
          </p>
          <p className={styles.editorial_board}>
              <strong>Associate Editor</strong> - <span>Alexander William</span> <em>Salter, Texas Tech University</em>
          </p>
          <p className={`mb-5 ${styles.final_editorial}`}>
              <strong>Production Manager</strong> - <span>Harry</span> <em>David</em>
          </p>

        </Col>

        <Col md={8} className="text-justify"> 
          <p className={styles.paragraph}>
            <em>The Journal of Private Enterprise</em> is a quarterly, double blind, peer-reviewed academic journal published by The Association of Private Enterprise Education (APEE). 
            <em> The Journal of Private Enterprise</em> brings together scholars in such fields as economics, management, entrepreneurship, marketing, finance, ethics, religion, and education who have done research on topics pertaining to systems of private enterprise worldwide. 
            The journal is listed in ABI/INFORM-ProQuest, Cabell’s, Cengage/ThomsonGale, EBSCO, EconLit, the Journal of Economic Literature, Public Affairs Information Service, Research Papers in Economics (RePEc), and Urlich’s.
          </p>
          <p className={styles.paragraph}>
              The Journal invites submissions at our <a href="https://www.editorialmanager.com/jpenterprise/default.aspx" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>Editorial Manager portal</a>. There is no submission fee.
          </p>

          <p className={styles.paragraph}> 
            Since its founding in 1985, <em> The Journal of Private Enterprise </em> has become an important forum for scholarship in private enterprise. 
            It has developed a rich mix of contributors ranging from Nobel Prize winners to promising younger scholars, spanning the full range of areas where private 
            enterprise applies, including economics, entrepreneurship, public policy, history, religion, and philosophy.
          </p> 

          <p className={styles.paragraph}> 
            Each year, the Editorial Board selects one article to receive the  <a href="https://apee.org/journal-best-paper/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}> Best Paper Award </a>. and one article to receive the  <a href="https://apee.org/journal-best-educational-note/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>Best Educational Note Award</a>. 
            The awards are presented at the APEE Annual Meeting.
          </p> 

          <p className={styles.paragraph}> 
          A subscription to the Journal is included with  <a href="https://apee.org/membership/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}> Best Paper Award </a>. and one article to receive the  <a href="https://apee.org/journal-best-educational-note/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}> membership </a> in The Association of Private Enterprise Education. 
          Individual and library subscriptions without APEE membership can be purchased for $24 per year by contacting Edward P. Stringham, Editor, <em> The Journal of Private Enterprise </em>, Trinity College, 300 Summit Street, Hartford, CT 06106 . 
          Past Issues of <em> The Journal of Private Enterprise </em> are available at that address for $10.00 a copy plus $2.00 postage.
          </p> 

        </Col>
      </Row>
      
      <Row className="mt-5">
        <div style={{ width: '100%', backgroundColor: '#C8C6C7', height: '2px', marginLeft: 'auto', marginRight: 'auto' }}></div>
        <h4 className={`mt-5 font-weight-bold ${styles.title_h4}`}> 
          Editorial Board
        </h4> 
        <Col md={5} className="mt-5 text-justify">
          {renderList(firstHalf)}
        </Col>
        
        <Col md={1} className="mt-5">
          <div style={{ width: '1px', backgroundColor: '#C8C6C7', height: '100%', marginLeft: 'auto', marginRight: 'auto' }}></div>
        </Col>

        <Col md={5} className="mt-5 text-justify">
          {renderList(secondHalf)}
        </Col>
      </Row>

    </Container>

  )
}
